export const DSR_COMMENT = 'dsr_comment';
